<template>
    <div class="group-wrapper">
        <div class="group-operate-bar">
            <Search :placeholder="groupHolder" class="group-search" @searchChange="groupSearch" @inputChange="groupSearch"></Search>
            <RoundButton @btnClick="addGroupHandle" :text="addGroupLabel" />
        </div>
        <div class="group-content">
            <Table class="group-table-list" :config="tableConfig" :dataset="groupData" @pageChange="pageChange" />
        </div>
        <div class="page-control">
            <PageControl :total="groupTotal" :curPage="curPage" :lengthRank="pageLengthRank" :pageLength="10" @pageChange="pageChange" />
        </div>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import Table from "@/views/zhiji/bComponents/table/Table";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import GroupEditModal from "./GroupEditModal";

import { groupTableConfig } from "../../personConfig.js";
import { debounce } from "@/views/zhiji/js/common/util.js";

export default {
    name: "GroupManage",
    components: {
        RoundButton,
        Search,
        Table,
        PageControl
    },
    data() {
        return {
            curPage: 1,
            curPageLen: 10,
            pageLengthRank: 10
        };
    },
    computed: {
        tableConfig() {
            return groupTableConfig();
        },
        addGroupLabel() {
            return this.$t("zhiji.personnel.addBtnLabel");
        },
        groupHolder() {
            return this.$t("zhiji.personnel.groupManage.searchGroupTip");
        },
        groupData() {
            return this.getStorePorp("groupData");
        },
        groupTotal() {
            return this.getStorePorp("groupListTotal");
        }
    },
    watch: {
        groupHolder() {
            this.$store.commit("zhiji/clearGroupOption");
            this.$store.commit("zhiji/clearRoleOption");
            this.getGroupListData();
        }
    },
    mounted() {
        this.getGroupListData();
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchByGroupName(searchField);
        }, 500);
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.personnelManage[propName];
        },
        getGroupListData() {
            this.$store.dispatch("zhiji/queryGroupList", {
                page: this.curPage,
                size: this.curPageLen
            });
        },
        addGroupHandle() {
            this.$store.dispatch("zhiji/showModal", {
                type: GroupEditModal,
                data: ""
            });
        },
        groupSearch(data) {
            this.searchHanlder(data);
        },
        searchByGroupName(data) {
            this.curPage = 1;
            this.$store.dispatch("zhiji/queryGroupList", {
                page: this.curPage,
                groupName: data.value
            });
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;

            this.getGroupListData();
        }
    }
};
</script>

<style lang="less" scoped>
.group-wrapper {
    margin: 16px 24px 16px 16px;
    padding: 0 24px 24px;
    background: #fff;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    .group-operate-bar {
        padding: 16px 24px 16px 0;
        background: #fff;
        border-bottom: 1px solid #d8e4f0;
        margin-bottom: 16px;

        .group-search {
            margin-right: 10px;
            font-size: 14px;
            width: 250px;
            margin-right: 30px;
            padding: 7px 0;
        }
    }

    .group-content {
        border-width: 0 1px 1px;
        border-style: solid;
        border-color: #e3ecf5;
        box-sizing: border-box;
    }

    .page-control {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        text-align: center;
        color: rgba(65, 71, 94, 0.7);
    }
}
</style>
